import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { isMaterialModule } from 'projects/is-ui-kit/src/public-api';

@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule,
    ...isMaterialModule
  ],
  exports: [
    LoginComponent
  ]
})
export class LoginModule { }
